/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PartitionValueRange { 
    /**
     * The start partition value for the partition value range. Required when partitionValueRange is present
     */
    startPartitionValue: string;
    /**
     * The end partition value for the partition value range. Required when partitionValueRange is present
     */
    endPartitionValue: string;
}
